<ng-container *ngIf="isVisible !== undefined && isVisible === true">
  <div id="short-message" [innerHTML]="content"></div>
</ng-container>
